import { useSites } from 'store/site';
import { DocumentationTranslationKeys } from 'intl/keys';
import { keepUndeleted } from 'shared/domain/deletable/filters';
import { toLabelledEntity } from 'components/inspection/Form/model';
import { createEntityFilterInput } from '../common';

export const SiteFilterInput = createEntityFilterInput({
  useData: () => {
    const { items } = useSites();
    return items;
  },
  transformData: (sites) => sites.filter(keepUndeleted).map(toLabelledEntity),
  labelId: DocumentationTranslationKeys.columnLabelSite,
  id: 'site-filter',
});
